export async function numberwithmax(fieldId: string, placeholder: string, hasError: boolean, min: number = null, max: number = null) {

    await import('@syncfusion/ej2-base/styles/bootstrap4.css');
    await import('@syncfusion/ej2-buttons/styles/bootstrap4.css');
    await import('@syncfusion/ej2-popups/styles/bootstrap4.css');
    await import('@syncfusion/ej2-splitbuttons/styles/bootstrap4.css');
    await import('@syncfusion/ej2-inputs/styles/bootstrap4.css');

    await import('./loadSyncfusion');

    const { NumericTextBox } = await import('@syncfusion/ej2-inputs');

    const containerEle = document.getElementById('container_' + fieldId);
    const inputEle = document.getElementById('input_' + fieldId);

    if (containerEle.hasAttribute("data-numerictextbox")) {
        var element: any = inputEle;
        var ej2 = element.ej2_instances[0];
        ej2.max = max;
        (inputEle.parentNode as HTMLElement).classList.toggle('e-error', hasError);
        return;
    }

    containerEle.setAttribute('data-numerictextbox', 'true');

    let ddObject = new NumericTextBox({
        // sets the placeholder
        floatLabelType: "Never",
        placeholder: null,
        min: min,
        max: max,
        change: (args: any) => {
            inputEle.setAttribute('value', ddObject.value?.toString());
            (document.getElementById("updatebutton") as HTMLButtonElement).click();
        },
        created: (args: any) => {
            (inputEle.parentNode as HTMLElement).classList.toggle('e-error', hasError);
            containerEle.style.display = null;
        }
    });
    ddObject.appendTo('#input_' + fieldId);
}